import React, {useContext, useEffect, useState} from 'react';
import {AddIcon, LoadingIcon} from "../../assets/icons/Icons";
import FormSection from "../form/Section";
import FormHeader from "../form/Header";
import Popup from "../Popup";
import { CreateUser } from "../../api/users/createUser";
import RoleSelect from "../form/RoleSelect";
import CustomPhoneInput from "../form/CustomPhoneInput";
import OfficesSelect from "../form/OfficesSelect";
import useForm from "../../hooks/useForm";
import FormErrorsOutput from "../form/FormErrorsOutput";
import {useTranslation} from "react-i18next";
import useRoleOfficeShape from "../../hooks/useRoleOfficeShape";

const CreateUserForm = ({onCreate, onClose, ...props}) => {

    const { t } = useTranslation();

    const [submitDisabled, setSubmitDisabled] = useState(true);

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [role , setRole] = useState('');
    const [roleName , setRoleName] = useState('');
    const [office_ids , setOfficeIds] = useState([]);
    const [email , setEmail] = useState('');
    const [phone , setPhone] = useState('');

    const {loading, error, fieldErrors, handleSubmit } = useForm(onCreate);

    // Office shape comes from the role's permission bundle (all_offices.read),
    // with the legacy name list as fallback.
    const officeScoped = useRoleOfficeShape(role, roleName);

    const handleFormSubmit = (e) => {
        e.preventDefault();
        // Only office-scoped roles carry offices; all-office roles submit none.
        const office_ids_to_send = officeScoped ? office_ids : [];
        handleSubmit(CreateUser, {firstName, lastName, email, role, office_ids: office_ids_to_send, phone});
    };

    const handleOfficeChange = (value) => {
        if (Array.isArray(value)){
            setOfficeIds(value)
        } else {
            setOfficeIds([value])
        }
    }

    useEffect(() => {
        if(firstName && lastName && email && role){
            setSubmitDisabled(false);
        } else {
            setSubmitDisabled(true);
        }
    }, [firstName, lastName, email, role]);

    return (
        <Popup size="large" withClose withOverlay onClose={onClose}>

            <form method="post" onSubmit={handleFormSubmit}>

                <FormHeader title={t("Create")}
                            description={t("Input accurate data entry to facilitate smooth user management.")}
                            className="mb-5"></FormHeader>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("First Name")} required>
                            <input type="text" name="first_name" id="first_name" maxLength="50"
                                   placeholder={t("User first name, max 50 characters")} value={firstName}
                                   onChange={e => setFirstName(e.target.value)}/>
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Last Name")} required>
                            <input type="text" name="last_name" id="last_name" maxLength="50"
                                   placeholder={t("User last name, max 50 characters")} value={lastName}
                                   onChange={e => setLastName(e.target.value)}/>
                        </FormSection>
                    </div>
                </div>
                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("Email")} required>
                            <input type="email" name="email" id="email" placeholder="user@example.com" value={email}
                                   onChange={e => setEmail(e.target.value)}/>
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Role")} required>
                            <RoleSelect value={role} onChange={option => { setRole(option.value); setRoleName(option.name); }}/>
                        </FormSection>
                    </div>
                </div>

                {officeScoped && <div className="row mb-5">
                    <div className="col-xs-12">
                        <FormSection title={t("Office")}>
                            <OfficesSelect
                                isMulti={roleName !== 'agent'}
                                onChange={handleOfficeChange}
                            />
                        </FormSection>
                    </div>
                </div>}

                <div className="row">
                    <div className="col-xs-6">
                        <FormSection title={t("Phone Number")}>
                            <CustomPhoneInput
                                country={'ca'}
                                onChange={(phone) => setPhone(phone.slice(1))}
                                onlyCountries={['ca']}
                            />
                        </FormSection>
                    </div>
                </div>
                <div className="text-right">
                    <button className={`btn btn-primary btn-medium ${loading ? 'btn-loading' : ''}`} type="submit"
                            name="submit" disabled={submitDisabled}>
                        {loading ? <LoadingIcon/> : <AddIcon/>}
                        {t("Add")}
                    </button>
                </div>
                <FormErrorsOutput error={error} fieldErrors={fieldErrors}/>
            </form>
        </Popup>
    );
};

export default CreateUserForm;